import {
    maskitoTimeOptionsGenerator,
} from '@maskito/kit';

type ConverTimeProps = {
    time: string;
    hoursText: string;
    minutesText: string;
}

export const convertTime = ({hoursText, minutesText, time}: ConverTimeProps) => {
    const [hours, minutes] = time.split(':');

    if (Number(hours) <= 2) {
        const displayMinutes =
            (Number(hours) * 60) + (minutes ? Number(minutes) : 0);

        return `${displayMinutes} ${minutesText}`;
    }

    if (hours && (!minutes || Number(minutes) === 0)) {
        return `${Number(hours)} ${hoursText}`;
    }

    return `${Number(hours)} ${hoursText} ${Number(minutes)} ${minutesText}`;
};

export const maskitoOptions = maskitoTimeOptionsGenerator({
    mode: 'HH:MM',
});
